const dev = {
  base_url: "http://localhost:4000/api",
  helpdesk_base_url: "http://localhost:4001/api",
  partner_url: "http://localhost:8081/registration?pr=",
  application_url: "http://localhost:8081",
  color: false,
};

const staging = {
  base_url: "https://staging-cnb-api.vidya-realm.info/api",
  helpdesk_base_url: "https://staging-helpdesk.vidya-realm.info/api",
  partner_url: "https://staging-cnb-app.vidya-realm.info/registration?pr=",
  application_url: "https://staging-cnb-app.vidya-realm.info",  
  color: true,
};

const production = {
  base_url: "https://cnb-api.vidya-realm.com/api",
  helpdesk_base_url: "https://cnb-helpdesk.vidya-realm.com/api",
//   partner_url: "https://cnb-app.vidya-realm.com/registration?pr=",
  partner_url: "https://eadmissions.sastra.edu/registration?pr=",
  application_url: "https://eadmissions.sastra.edu",
  color: false,
};

export default staging;
